/* istanbul ignore file */
export enum SPACE_KEYS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=25277234.
     */
    ABOUT_DIALOG_TITLE = 'FRONT.COMMUNITY.ABOUT_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7263679.
     */
    ABOUT_TAB_DESCRIPTION = 'GLOBAL.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=86406130.
     */
    ABOUT_TAB_MEMBERS = 'FRONT.COMMUNITY.CONFIGURATION_DIALOG.TAB.MEMBERS.TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=304566305
     */
    ACCESS_REQUEST = 'SPACES.ACCESS_REQUEST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=304566358
     */
    ACCESS_REQUEST_PENDING = 'SPACES.ACCESS_REQUEST_PENDING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=304019043
     */
    COMMUNITY_VISIBILITY_RESTRICTED = 'COMMUNITIES.COMMUNITY_VISIBILITY_RESTRICTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=294931537
     */
    GO_TO_ARTICLE_LIST = 'SPACES.GO_TO_ARTICLE_LIST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=299733456
     */
    GO_TO_EVENT_LIST = 'SPACES.GO_TO_EVENT_LIST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=298565600
     */
    NO_MEMBERS = 'SPACES.NO_MEMBERS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=365167021
     */
    GOOGLE_DRIVE_FOLDER = 'SPACES.CONFIGURATION_GOOGLE_DRIVE_FOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=365170996
     */
    ONEDRIVE_FOLDER = 'SPACES.CONFIGURATION_ONEDRIVE_FOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=619130753
     * */
    DRIVE_ACCESS_WARNING = 'SPACES.CONFIGURATION_ACCESS_WARNING_DRIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=619129917
     * */
    CALENDAR_ACCESS_WARNING = 'SPACES.CONFIGURATION_ACCESS_WARNING_CALENDAR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=365184768
     * */
    THIRD_PARTY_SERVICES = 'SPACES.CONFIGURATION_THIRD_PARTY_SERVICES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=365184772
     * */
    THIRD_PARTY_INTEGRATION = 'SPACES.CONFIGURATION_THIRD_PARTY_INTEGRATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=109930867
     * */
    GOOGLE_CALENDAR = 'WIDGET_EVENT_METADATA.GOOGLE_CALENDAR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=110500292
     * */
    MS_CALENDAR = 'COMMUNITIES.OFFICE_365_GROUP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=584921873
     * */
    SELECT_CALENDAR = 'SPACES.CONFIGURATIONS_SELECT_CALENDAR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=637816218
     */
    PINNED_POSTS = 'SPACES.PINNED_POSTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623823307
     */
    PINNED_POSTS_PLURAL = 'SPACES.PINNED_POSTS_PLURAL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=685388093
     */
    EMPTY_DRAFT_POST_LIST_TITLE = 'SPACES.EMPTY_DRAFT_POST_LIST_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=685389820
     */
    EMPTY_DRAFT_POST_LIST_MESSAGE = 'SPACES.EMPTY_DRAFT_POST_LIST_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=685715407
     */
    EMPTY_SCHEDULED_POST_LIST_TITLE = 'SPACES.EMPTY_SCHEDULED_POST_LIST_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=685715442
     */
    EMPTY_SCHEDULED_POST_LIST_MESSAGE = 'SPACES.EMPTY_SCHEDULED_POST_LIST_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=707733932
     */
    DRAFT_AND_SCHEDULED_POST_LINKS = 'SPACES.DRAFT_AND_SCHEDULED_POST_LINKS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=707764662
     */
    DRAFT_POST_LINK = 'SPACES.DRAFT_POST_LINK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=707767654
     */
    SCHEDULED_POST_LINK = 'SPACES.SCHEDULED_POST_LINK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=742181064
     */
    DRAFT_POSTS = 'SPACES.DRAFT_POSTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=742181085
     */
    SCHEDULED_POSTS = 'SPACES.SCHEDULED_POSTS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721009182
     */
    NO_METADATA_SELECTED = 'SPACES.NO_METADATA_SELECTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=721009680
     */
    COUNT_METADATA_SELECTED_PLURALIZE = 'SPACES.COUNT_METADATA_SELECTED_PLURALIZE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=736790561
     */
    METADATA_EMPTY_STATE_TITLE = 'SPACES.METADATA_EMPTY_STATE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=736792657
     */
    METADATA_EMPTY_STATE_DESCRIPTION = 'SPACES.METADATA_EMPTY_STATE_DESCRIPTION',
}
